var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"all-panel"},[(_vm.showResult)?_c('van-button',{staticStyle:{"margin-top":"300px"},attrs:{"type":"primary"}},[_vm._v(_vm._s(_vm.text))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }